import { FormSection } from "components/MainSectionTemplate/types";
import CompanyModalPicker from "components/Picker/CompanyPicker/CompanyModalPicker";
import ContactModalPicker from "components/Picker/ContactPicker/ContactModalPicker";
import React from "react";
import ReadonlyCompany from "show/detail/components/ReadonlyCompany";
import ReadonlyContact from "show/detail/components/ReadonlyCompanyContact";
import { getInstructionForInternal, ShowInfo } from "show/detail/utils";
export const hotelSection = (
  show: server.dto.Show,
  showInfo: ShowInfo,
  isExternal: boolean,
  isSidebar: boolean
): FormSection => {
  const isInternalUser = !isExternal;

  const section: FormSection = {
    type: "regular",
    key: "showHotelSection",
    title: site.currentEnvironment.functionGroups.hotel.singular,
    hidden: !site.currentEnvironment.functionGroups.hotel.enabled,
    fields: [{
      key: "hotel",
      label: site.currentEnvironment.functionGroups.hotel.singular,
      isEmpty: !showInfo.hotel,
      render: () => <ReadonlyCompany company={showInfo.hotel} displayAs="hotel" displayTooltip={isInternalUser} />,
      inPageEdit: {
        hoverEdit: true,
        canRemove: true,
        initialValue: showInfo.hotel,
        fullWidth: true,
        render: ({ onChange, cancel, value }) => (
          <div className="main-section-template-fields-padding">
            <CompanyModalPicker
              modalTitle={site.currentEnvironment.functionGroups.hotel.singular}
              addressType="regular"
              inPageEditing={{ onChange, cancel, hasValue: Boolean(value) }}
              canCreateNew={!isSidebar && site.permissions.addressBook.canCreate}
              afterCreate={isSidebar ? "goBack" : "closeSidebar"}
            />
          </div>
        ),
        type: "custom",
        submitChange: (value: server.dto.CompanySmall) =>
          window.CoreApi.Show.UpdateForInternalEnvironment(
            getInstructionForInternal(show.showId, showInfo, {
              hotelCompanyId: value?.companyId ?? null,
              hotelContactId: null,
            })
          )
      }
    }, {
      key: "hotelContact",
      hidden: showInfo.hotel == null,
      label: RESX.Contact.resxContact,
      isEmpty: !showInfo.hotelContact,
      render: () => <ReadonlyContact contact={showInfo.hotelContact} displayDetails displayPreview={isInternalUser} />,
      inPageEdit: {
        initialValue: showInfo.hotelContact,
        fullWidth: true,
        hoverEdit: true,
        canRemove: true,
        render: ({ onChange, cancel, value }) => (
          <div className="main-section-template-fields-padding">
            <ContactModalPicker
              inPageEditing={{ onChange, cancel, hasValue: Boolean(value) }}
              fromCompanyId={showInfo.hotel?.companyId}
              canCreateNew={!isSidebar && site.permissions.addressBook.canCreate}
              afterCreate={isSidebar ? "goBack" : "closeSidebar"}
            />
          </div>
        ),
        type: "custom",
        submitChange: (value: server.dto.ContactSmallV2) =>
          window.CoreApi.Show.UpdateForInternalEnvironment(
            getInstructionForInternal(show.showId, showInfo, { hotelContactId: value?.contactId ?? null })
          )
      }
    }]
  };

  if (isExternal) {
    section.fields = section.fields.map(f => ({ ...f, editDisabled: true }));
  }
  return section;
};
